module.exports = __webpack_public_path__ + "img/anli-5.352f4ebe.png";